import React from "react";
import { RECAPTCHA_ENABLED } from "@/lib/recaptcha";
import { useLang } from "@/context/LanguageContext";

// Legal disclosure required by Google when using reCAPTCHA. Rendered under every
// protected form. Hidden automatically when reCAPTCHA isn't configured.
export const RecaptchaNotice = ({ className = "" }) => {
  const { t } = useLang();
  if (!RECAPTCHA_ENABLED) return null;
  return (
    <p className={`text-[11px] leading-snug text-slate-400 ${className}`} data-testid="recaptcha-notice">
      {t("hc.protectedByRecaptcha")} —{" "}
      <a href="https://policies.google.com/privacy" target="_blank" rel="noreferrer" className="underline hover:text-slate-600">
        {t("hc.privacy")}
      </a>{" "}
      {t("hc.and")}{" "}
      <a href="https://policies.google.com/terms" target="_blank" rel="noreferrer" className="underline hover:text-slate-600">
        {t("hc.terms")}
      </a>.
    </p>
  );
};

export default RecaptchaNotice;
